import React,{useState,useEffect,useRef} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import {Grid,Typography,Button} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import {makeStyles} from '@mui/styles';
import Grow from '@mui/material/Grow';
import Slide from '@mui/material/Slide';
import Zoom from '@mui/material/Zoom';
import SocialContainer from './../components/SocialContainer'
import Divider from '@mui/material/Divider'
import NavBar from './../components/NavBar'
import EmailContainer from './../components/EmailContainer'
import Intro from './Intro'
import About from './About'
import WorkExperience from './WorkExperience'
import TopProjects from './TopProjects';
import GetInTouch from './GetInTouch'

import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import Link from '@mui/material/Link';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallIcon from '@mui/icons-material/Call';

const useStyles= makeStyles(theme=>({
   root:{
    backgroundColor:'#0a192f'
   },
   homeScreen:{
       backgroundColor:'#0a192f',
       

   },
   emailContainer:{
        display:'flex',
        flexDirection:'row',justifyContent:'space-between',border:'1px solid white'

   },
   divider:{
       color:'black',
       height:'150px'
       
    },
    email:{
        marginBottom:'100px',
        '&:hover':{
            color:'#64ffda'
        }
    },'@global': {
        '*::-webkit-scrollbar': {
          width: '0.5em'
        },
        '*::-webkit-scrollbar-track': {
          '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
          backgroundColor:'#0a192f'
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#a8b2d1',
          outline: '1px solid slategrey',
          borderRadius:'10px'
        }
      },
      socialIconStyle:{
        color:'#a8b2d1',
        '&:hover':{
            color:'#64ffda'
        }

    },
    socialContainer:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        boder:'1px solid green',
        [theme.breakpoints.down("800")]:{
          width:'98%',justifyContent:'center'
      }
       
       
    }
    
}))


 const HomeScreen = () => {
     const classes = useStyles();
     const [windowWidth, setWindowWidth] = useState(window.innerWidth)
     const [openDrawer,setOpenDrawer] = useState(false)

     const introRef= useRef(null)
     const aboutRef= useRef(null)
     const workExperienceRef = useRef(null)
     const topProjectsRef = useRef(null)
     const getInTouchRef = useRef(null)

     useEffect(() => {
     
    }, [introRef,aboutRef,workExperienceRef,topProjectsRef,getInTouchRef]);
   
     useEffect(() => {
       function handleResize() {
         setWindowWidth(window.innerWidth)
       }
   
       window.addEventListener('resize', handleResize)
       return () => window.removeEventListener('resize', handleResize)
     }, [])
 
     function handleClose(){
         setOpenDrawer(false)
     }
 
    

    return (
        <div className={classes.root}>

            {/*Navigation bar */}
            <NavBar
              introRef={introRef}
              aboutRef={aboutRef}
              workRef={workExperienceRef}
              projectRef={topProjectsRef}
              getInTouchRef={getInTouchRef}
            />
           

            <div className={classes.homeScreen}>
                
                {windowWidth>800?<SocialContainer/>:null}
                {windowWidth>800?<EmailContainer/>:null}

                {/*Intro */}
                <Intro refer={introRef}/>

                {/*About */}
                <About refer={aboutRef}/>

                {/*Work Experience */}
                <WorkExperience refer={workExperienceRef}/>

                {/*Top projects */}
                <TopProjects refer={topProjectsRef}/>

                {/*Get in touch */}
                <GetInTouch refer={getInTouchRef}/>

               
             

                {/*contact info for mobile users */}
                {windowWidth<800?<Box className={classes.socialContainer} style={{padding:'15px 5px 15px 5px',alignSelf:'center'}}>
                
                        <IconButton><Link target="_blank" href={"https://github.com/Suprith461"}><GitHubIcon   className={classes.socialIconStyle}/></Link></IconButton>
                        <IconButton><Link target="_blank" href={"https://www.linkedin.com/in/suprith-hattikal-983b011a1/"}><LinkedInIcon className={classes.socialIconStyle}/></Link></IconButton>
                        <IconButton><Link target="_blank" href={"https://www.instagram.com/suprith.p.h/"}><InstagramIcon className={classes.socialIconStyle}/></Link></IconButton>
                        <IconButton><Link target="_blank" href={"https://twitter.com/p_suprith"}><TwitterIcon  className={classes.socialIconStyle}/></Link></IconButton>
                        <IconButton><Link target="_blank" href={"https://www.facebook.com/profile.php?id=100009023124792"}><FacebookIcon className={classes.socialIconStyle}/></Link></IconButton>
                        <IconButton><Link target="_blank" href={"https://mail.google.com/mail/?view=cm&fs=1&to=suprithhattikal461@gmail.com"}><MailOutlineIcon className={classes.socialIconStyle}/></Link></IconButton>
                 
                </Box>:null}
                

            </div>

        </div>
    )
}
export default HomeScreen